const MAIN_HEADER_MENU = document.getElementById("main-header-menu");
const MAIN_HEADER_MENU_MOBILE_OVERLAY = document.getElementsByClassName("js-main-header-mobile-overlay")[0];
const MAIN_HEADER_MENU_MOBILE = document.getElementsByClassName("js-main-header-menu-mobile")[0];
const MAIN_HEADER_MENU_MOBILE_CLOSE_BUTTON = document.getElementsByClassName("js-main-header-menu-close-icon")[0];
const MOBILE_NAV_DROPDOWNS = document.querySelectorAll('.js-mobile-nav-dropdown');

if (MAIN_HEADER_MENU) {
    MAIN_HEADER_MENU.addEventListener('click', () => {
        if (MAIN_HEADER_MENU_MOBILE_OVERLAY && MAIN_HEADER_MENU_MOBILE_OVERLAY.classList.contains('d-none')) {
            MAIN_HEADER_MENU_MOBILE_OVERLAY.classList.remove('d-none');
        }
    });
}

if (MAIN_HEADER_MENU_MOBILE_OVERLAY) {
    MAIN_HEADER_MENU_MOBILE_OVERLAY.addEventListener('click', (event) => {
        if (MAIN_HEADER_MENU_MOBILE_OVERLAY && !MAIN_HEADER_MENU_MOBILE_OVERLAY.classList.contains('d-none')) {
            MAIN_HEADER_MENU_MOBILE_OVERLAY.classList.add('d-none');
        }
    });
}

if (MAIN_HEADER_MENU_MOBILE) {
    MAIN_HEADER_MENU_MOBILE.addEventListener('click', (event) => {
        event.stopPropagation();
    });
}

if (MAIN_HEADER_MENU_MOBILE_CLOSE_BUTTON) {
    MAIN_HEADER_MENU_MOBILE_CLOSE_BUTTON.addEventListener('click', () => {
        if (MAIN_HEADER_MENU_MOBILE_OVERLAY && !MAIN_HEADER_MENU_MOBILE_OVERLAY.classList.contains('d-none')) {
            MAIN_HEADER_MENU_MOBILE_OVERLAY.classList.add('d-none');
        }
    });
}

if (MOBILE_NAV_DROPDOWNS && MOBILE_NAV_DROPDOWNS.length > 0) {
    MOBILE_NAV_DROPDOWNS.forEach((dropdown) => {
        const toggle = dropdown.querySelector('.js-mobile-nav-dropdown-toggle');
        const menu = dropdown.querySelector('.js-mobile-nav-dropdown-menu');

        if (!toggle || !menu) {
            return;
        }

        const isInitiallyOpen = menu.classList.contains('is-open');
        toggle.setAttribute('aria-expanded', isInitiallyOpen ? 'true' : 'false');

        toggle.addEventListener('click', (event) => {
            event.preventDefault();
            const isOpen = menu.classList.contains('is-open');

            if (isOpen) {
                menu.classList.remove('is-open');
                toggle.classList.remove('is-active');
                toggle.setAttribute('aria-expanded', 'false');
                return;
            }

            menu.classList.add('is-open');
            toggle.classList.add('is-active');
            toggle.setAttribute('aria-expanded', 'true');
        });
    });
}

// Header Global VIN Decoder
function checkLogoVisibility() {
    const mainHeader = document.querySelector('.main-header');
    const mainHeaderNav = document.querySelector('.main-header-desktop-nav');
    const logo = document.querySelector('.main-header-logo');
    const logoText = document.querySelector('.main-header-logo-section-text');
    const menuOverlay = document.querySelector('.main-header-menu-mobile-overlay');
    const logoTextWidth = 115;

    if(!mainHeader || !mainHeaderNav){
        return;
    }

    const mainHeaderNavWidth = mainHeaderNav.offsetWidth +
        parseFloat(getComputedStyle(mainHeaderNav).marginLeft) +
        parseFloat(getComputedStyle(mainHeaderNav).marginRight);

    const menuOverlayWidth = menuOverlay ? menuOverlay.offsetWidth : 0;

    const totalWidthRequired = logo.offsetWidth + mainHeaderNavWidth + menuOverlayWidth + logoTextWidth;

    if (totalWidthRequired <= mainHeader.offsetWidth) {
        logoText.style.display = 'inline-block';
    } else {
        logoText.style.display = 'none';
    }
}

let resizeTimeout;
window.addEventListener('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(checkLogoVisibility, 100);
});

document.addEventListener('DOMContentLoaded', checkLogoVisibility);
